import Perfume from 'perfume.js'
import { track as trackError } from 'lib/utils/errors'
import typewriter from 'analytics/typewriter'
import RouteTracker from './route-tracker'
import { trackAppPerformance } from './utils/stats'
import { APP_ENV } from '../config'

function parseIdentifiersFromMetricName(metricName: string) {
  const [metric, componentName] = metricName.split('|')
  return {
    metric,
    componentName
  }
}

const defaultOptions = {
  logPrefix: 'App Perf:',
  logging: APP_ENV === 'development',
  analyticsTracker: async (metricName, duration, browser) => {
    try {
      const route = await RouteTracker.getCurrentRoute()
      const team = RouteTracker.currentTeam
      const { metric, componentName } = parseIdentifiersFromMetricName(metricName)

      const attributes = {
        browser,
        duration,
        route
      }

      if (metric === 'firstInputDelay') {
        typewriter.firstInputDelay(attributes)
      } else if (metric === 'firstContentfulPaint') {
        typewriter.firstContentfulPaint(attributes)
      } else if (metric === 'firstPaint') {
        typewriter.firstPaint(attributes)
      } else {
        typewriter.appTimingMetric({
          ...attributes,
          metric,
          team,
          component_name: componentName
        })
      }

      trackAppPerformance({
        event: metric,
        duration,
        route,
        team: metric === 'componentLoading' ? team : undefined,
        componentName
      })
    } catch (err) {
      trackError(err)
    }
  }
}

class Performance extends Perfume {
  constructor(opts = {}) {
    super({
      ...defaultOptions,
      ...opts
    })
  }

  startComponentTimer(metricName: string, componentName: string): void {
    super.start(this.buildMetricName(metricName, componentName))
  }

  endComponentTimer(metricName: string, componentName: string): void {
    super.endPaint(this.buildMetricName(metricName, componentName)).catch(trackError)
  }

  private buildMetricName(metricName: string, componentName: string): string {
    return `${metricName}|${componentName}`
  }
}

/**
 * Track first paint, contentful paint and first paint only in the main instance here
 */
export const globalPerformance = new Performance({
  firstContentfulPaint: true,
  firstInputDelay: true,
  firstPaint: true
})

export default Performance
